<template>
	<div class="netteach">
		<div class="netteach-nav">
			<div class="netteach-nav-type">
				<span>类型：</span>
				<div>
					<el-radio-group v-model="typeval" @change="getNetteach">
						<el-radio :label="0"> 所有</el-radio>
						<el-radio :label="1">我发起的</el-radio>
						<el-radio :label="2">邀请我的</el-radio>
						<el-radio :label="3">我未参与的</el-radio>
					</el-radio-group>
				</div>
			</div>

			<div class="netteach-nav-type">
				<span>状态：</span>
				<div>
					<el-radio-group v-model="statusval" @change="getNetteach">
						<el-radio :label="0">所有</el-radio>
						<el-radio :label="1">未开始</el-radio>
						<el-radio :label="2">进行中</el-radio>
						<el-radio :label="3">已结束</el-radio>
					</el-radio-group>
				</div>
			</div>
		</div>

		<div class="netteach-content">
			
			<div class="netteach-screen">
				<!-- <span>发起时间 <i class="el-icon-sort-down"></i></span>
				<span>结束时间 <i class="el-icon-sort-down"></i></span>
				<span>得分 <i class="el-icon-sort-down"></i></span> -->

				<el-radio-group v-model="screenval" @change="getNetteach">
					<el-radio label="create_time">发起时间 <i class="el-icon-sort-down"></i></el-radio>
					<el-radio label="end_time">结束时间 <i class="el-icon-sort-down"></i></el-radio>
					<el-radio label="score">得分  <i class="el-icon-sort-down"></i></el-radio>
				</el-radio-group>
			</div>

			<ul class="netteach-list"  v-loading="loading"  element-loading-text="拼命加载中">

				<li class="netteach-list-li" v-for="(item, index) of netteachList" :key="index">
					<div class="netteach-list-title">
						
						<p @click="getStatus"  v-if="item._status === '未开始'">{{item.name}}</p>
						<router-link  v-else  :to="{path: '/netteach/details', query: {id: item.id}}">{{item.name}}</router-link>
						<div class="netteach-list-status">
							<i v-if="item.is_ping === 0" class="ipng weiping"></i>
							<i v-else class="ipng yiping"></i>
							<span>{{item.start_time}}-{{item.end_time}}</span>
						</div>
						<i v-if="item._status === '未开始' " class="ipng  weikaishi"></i>
						<i v-else-if="item._status === '进行中' " class="ipng  jinxingzhong "></i>
						<i v-else class="ipng  yijiesu"></i>
					</div>

					<div class="netteach-list-content" v-html="item.profile"></div>

					<div class="netteach-list-info">
						<div class="netteach-list-resource">
							<span>
								<i class="ipng cousevideo"></i>
								<strong>视频文件：{{item.video_num}}</strong>
							</span>
							<span>
								<i class="ipng cousepeople"></i>
								<strong>参与人数：{{item.comment_count}}/{{item.total_user}}</strong>
							</span>
						</div>

						<div class="netteach-list-initiator">
							<span>发起者：{{item.user_name}}</span>
							<span>{{item.org_name}}</span>
						</div>
					</div>
				</li>
			</ul>

			<el-pagination v-if="totalSum > pageSize" 
			     @size-change="sizeChange"
			     @current-change="currentChange"
			     :current-page="pageIndex"
			     :page-sizes="[10, 50, 100, 200, 300, 400]"
			     :page-size="pageSize"
			     layout="total, sizes, prev, pager, next, jumper"
			     :total="totalSum">
			</el-pagination>

			<div class="dependent" v-if="placeholder">
				<i class="ipng image_state01"></i>
				<p>还没发现任何相关的内容哦~</p>
			</div>
		</div>
	</div>
</template>

<script>
	
	export default{
		data(){
			return {
				typeval: 0,
				statusval: 0,
				screenval: 'create_time',
				netteachList: [],
				pageIndex: 1,
				pageSize: 12,
				totalSum: 0,
				loading: true,
				placeholder: true
			}
		},
		created(){
			this.getNetteach()
		},
		methods: {
			getStatus(){
				return this.$message.error('还未开始,请稍等')
			},
			/*
				获取数据列表
			 */
			getNetteach(){
				let success = (res =>{
					this.loading = false;
					this.netteachList = res.data.data;
					this.pageIndex = parseInt(res.data.page_index);
					this.totalSum = parseInt(res.data.data_sum);
					this.placeholder = this.netteachList.length === 0 ? true : false;
				});
				this.$ajax({
					url: 'api/network/eva_list',
					method: 'get',
					params: {
						page_index: this.pageIndex,
						page_size: this.pageSize,
						eva_type: this.typeval,
						eva_status: this.statusval,
						order: this.screenval,
						userid: this.$g.user_id

					},
					func: {success: success}
				})
			},
			sizeChange(val) {
				this.pageSize = val
				this.getNetteach();
			},
			currentChange(val) {

				this.pageIndex = val;
				this.getNetteach();
			}

		}
	}
</script>